(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartItems extends HTMLElement {
    connectedCallback() {
      this.moneyFormat = this.dataset.moneyFormat;
      this.list = this.querySelector('.cart-items');
      this.currentPriceEl = this.querySelector('[data-cart-current-price]');
      this.comparePriceEl = this.querySelector('[data-cart-compare-price]');
      this.promoToggle = this.querySelector('[data-cart-promo-toggle]');
      this.promoForm = this.querySelector('[data-cart-promo-form]');
      this.promoInput = this.querySelector('[data-cart-promo-input]');
      this.promoApply = this.querySelector('[data-cart-promo-apply]');
      this.promoMessage = this.querySelector('[data-cart-promo-message]');

      this.onListClick = this.onListClick.bind(this);
      this.onQuantityChange = this.onQuantityChange.bind(this);
      this.list.addEventListener('click', this.onListClick);
      this.list.addEventListener('change', this.onQuantityChange);

      if (this.promoToggle) {
        this.promoToggle.addEventListener('click', () => this.togglePromoForm());
      }
      if (this.promoApply) {
        this.promoApply.addEventListener('click', () => this.applyPromoCode());
      }
      if (this.promoInput) {
        this.promoInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.applyPromoCode();
          }
        });
      }
    }

    onListClick(event) {
      const decreaseBtn = event.target.closest('[data-cart-decrease]');
      const increaseBtn = event.target.closest('[data-cart-increase]');
      const removeBtn = event.target.closest('[data-cart-remove]');

      if (decreaseBtn) {
        const row = decreaseBtn.closest('[data-cart-item]');
        const input = row.querySelector('[data-cart-quantity-input]');
        const value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = value;
        this.updateLine(row, value);
      } else if (increaseBtn) {
        const row = increaseBtn.closest('[data-cart-item]');
        const input = row.querySelector('[data-cart-quantity-input]');
        const value = (parseInt(input.value, 10) || 1) + 1;
        input.value = value;
        this.updateLine(row, value);
      } else if (removeBtn) {
        const row = removeBtn.closest('[data-cart-item]');
        this.updateLine(row, 0);
      }
    }

    onQuantityChange(event) {
      const input = event.target.closest('[data-cart-quantity-input]');
      if (!input) return;
      const row = input.closest('[data-cart-item]');
      const value = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = value;
      this.updateLine(row, value);
    }

    async updateLine(row, quantity) {
      const key = row.dataset.key;
      row.classList.add('is-updating');

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity }),
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || 'cart error');

        if (quantity === 0) {
          row.remove();
        } else {
          const updatedItem = cart.items.find((cartItem) => cartItem.key === key);
          const priceEl = row.querySelector('[data-cart-line-price]');
          if (updatedItem && priceEl) {
            priceEl.textContent = this.formatMoney(updatedItem.final_line_price);
          }
          row.classList.remove('is-updating');
        }

        this.renderTotals(cart);
        this.dispatchCartUpdated(cart);

        if (cart.item_count === 0) {
          window.location.reload();
        }
      } catch (error) {
        window.location.reload();
      }
    }

    renderTotals(cart) {
      if (cart.total_discount > 0) {
        this.comparePriceEl.textContent = this.formatMoney(cart.original_total_price);
        this.comparePriceEl.hidden = false;
      } else {
        this.comparePriceEl.hidden = true;
      }
      this.currentPriceEl.textContent = this.formatMoney(cart.total_price);
      this.renderShippingProgress(cart.item_count);
    }

    renderShippingProgress(itemCount) {
      const reached = true; // livraison offerte pour tous (décision 2026-10-03)
      const shipping = this.querySelector('[data-cart-shipping]');
      if (shipping) shipping.classList.toggle('is-reached', reached);
      const freeLine = this.querySelector('[data-cart-shipping-free]');
      if (freeLine) freeLine.hidden = !reached;
    }

    dispatchCartUpdated(cart) {
      document.dispatchEvent(
        new CustomEvent('ballzi:cart:updated', { detail: { itemCount: cart.item_count } })
      );
    }

    togglePromoForm() {
      const isHidden = this.promoForm.hidden;
      this.promoForm.hidden = !isHidden;
      if (isHidden) this.promoInput.focus();
    }

    async applyPromoCode() {
      const code = this.promoInput.value.trim();
      if (!code) return;

      this.promoApply.disabled = true;
      this.promoMessage.hidden = true;
      this.promoMessage.classList.remove('is-success', 'is-error');

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code }),
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || 'cart error');

        this.renderTotals(cart);
        this.dispatchCartUpdated(cart);

        this.promoMessage.hidden = false;
        if (cart.total_discount > 0) {
          this.promoMessage.textContent = this.promoMessage.dataset.successText;
          this.promoMessage.classList.add('is-success');
        } else {
          this.promoMessage.textContent = this.promoMessage.dataset.invalidText;
          this.promoMessage.classList.add('is-error');
        }
      } catch (error) {
        this.promoMessage.hidden = false;
        this.promoMessage.textContent = this.promoMessage.dataset.errorText;
        this.promoMessage.classList.add('is-error');
      } finally {
        this.promoApply.disabled = false;
      }
    }

    formatMoney(cents) {
      if (!this.moneyFormat) return (cents / 100).toFixed(2);

      const placeholderMatch = this.moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      const placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';
      let thousands = ',';
      let decimal = '.';
      let precision = 2;

      if (placeholder === 'amount_no_decimals') {
        precision = 0;
      } else if (placeholder === 'amount_with_comma_separator') {
        thousands = '.';
        decimal = ',';
      } else if (placeholder === 'amount_no_decimals_with_comma_separator') {
        precision = 0;
        thousands = '.';
        decimal = ',';
      }

      const rounded = (cents / 100).toFixed(precision);
      const parts = rounded.split('.');
      const wholePart = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      const decimalPart = parts[1] ? decimal + parts[1] : '';

      return this.moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, wholePart + decimalPart);
    }
  }

  customElements.define('cart-items', CartItems);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderMenuToggle extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('header');
      this.button = this.querySelector('button');
      this.menu = document.getElementById(this.button.getAttribute('aria-controls'));
      this.desktopQuery = window.matchMedia('(min-width: 901px)');

      this.onButtonClick = () => this.setOpen(!this.isOpen());
      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.isOpen()) {
          this.setOpen(false);
          this.button.focus();
        }
      };
      this.onBreakpoint = (event) => {
        if (event.matches) this.setOpen(false);
      };

      this.button.addEventListener('click', this.onButtonClick);
      document.addEventListener('keydown', this.onKeydown);
      this.desktopQuery.addEventListener('change', this.onBreakpoint);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      this.desktopQuery.removeEventListener('change', this.onBreakpoint);
      document.documentElement.classList.remove('header-menu-open');
    }

    isOpen() {
      return this.button.getAttribute('aria-expanded') === 'true';
    }

    setOpen(open) {
      this.button.setAttribute('aria-expanded', open.toString());
      this.header.classList.toggle('is-menu-open', open);
      document.documentElement.classList.toggle('header-menu-open', open);

      if (open) {
        // The header scrolls with the page: bring it back to the top so the
        // drawer starts right under it.
        if (window.scrollY > 0) window.scrollTo(0, 0);
        const firstLink = this.menu.querySelector('a');
        if (firstLink) firstLink.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('header-menu-toggle', HeaderMenuToggle);

  class HeaderCartIcon extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-cart-icon]');
      this.countEl = this.querySelector('[data-cart-count]');
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onCartUpdated = this.onCartUpdated.bind(this);
      document.addEventListener('ballzi:cart:updated', this.onCartUpdated);
    }

    disconnectedCallback() {
      document.removeEventListener('ballzi:cart:updated', this.onCartUpdated);
    }

    onCartUpdated(event) {
      const { itemCount, sourceElement } = event.detail || {};
      if (typeof itemCount === 'number') {
        this.countEl.textContent = itemCount;
        this.countEl.hidden = itemCount === 0;
      }

      if (this.reducedMotionQuery.matches) return;

      this.flyToCart(sourceElement);

      this.link.classList.remove('header__cart-link--bump');
      // Force a reflow so the animation can restart on back-to-back adds.
      void this.link.offsetWidth;
      this.link.classList.add('header__cart-link--bump');
    }

    flyToCart(sourceImage) {
      if (!sourceImage) return;

      const sourceRect = sourceImage.getBoundingClientRect();
      const targetRect = this.link.getBoundingClientRect();
      if (sourceRect.width === 0 || sourceRect.height === 0) return;

      const clone = sourceImage.cloneNode(false);
      clone.removeAttribute('class');
      clone.classList.add('header__fly-to-cart-clone');
      clone.style.top = `${sourceRect.top}px`;
      clone.style.left = `${sourceRect.left}px`;
      clone.style.width = `${sourceRect.width}px`;
      clone.style.height = `${sourceRect.height}px`;
      clone.style.opacity = '1';
      clone.style.transform = 'translate(0, 0) scale(1)';
      clone.style.transition = 'transform 550ms cubic-bezier(0.55, 0, 0.1, 1), opacity 550ms ease';
      document.body.appendChild(clone);

      const deltaX = (targetRect.left + targetRect.width / 2) - (sourceRect.left + sourceRect.width / 2);
      const deltaY = (targetRect.top + targetRect.height / 2) - (sourceRect.top + sourceRect.height / 2);

      requestAnimationFrame(() => {
        clone.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.12)`;
        clone.style.opacity = '0.3';
      });

      window.setTimeout(() => clone.remove(), 600);
    }
  }

  customElements.define('header-cart-icon', HeaderCartIcon);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function formatMoney(cents, format) {
    function withDelimiters(number, precision, thousands, decimal) {
      number = (number / 100).toFixed(precision);
      const parts = number.split('.');
      const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      const fraction = parts[1] ? decimal + parts[1] : '';
      return whole + fraction;
    }

    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;

    let value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }

    return format.replace(match[0], value);
  }

  class ProductVariantPicker extends HTMLElement {
    connectedCallback() {
      const variantsScript = this.querySelector('[data-product-variants]');
      this.variants = JSON.parse(variantsScript.textContent);
      this.idInput = this.querySelector('.product__variant-id');
      this.submitButton = this.querySelector('.product__add-to-cart');
      this.fieldsets = Array.from(this.querySelectorAll('fieldset.product__option'))
        .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition);
      this.addEventListener('change', this.onOptionChange.bind(this));

      this.sizeFieldset = this.querySelector('fieldset[data-option-role="size"]');
      this.idealForText = this.querySelector('[data-ideal-for-text]');
      const idealForMapScript = this.querySelector('[data-ideal-for-map]');
      this.idealForMap = idealForMapScript ? JSON.parse(idealForMapScript.textContent) : null;

      this.colorFieldset = this.querySelector('fieldset[data-option-role="color"]');
      const productRoot = this.closest('.product');
      const colorMapScript = productRoot ? productRoot.querySelector('[data-gallery-color-map]') : null;
      this.galleryColorMap = colorMapScript ? JSON.parse(colorMapScript.textContent) : null;
      this.galleryMainImage = productRoot ? productRoot.querySelector('.product__gallery-main-image') : null;
      this.galleryPrevButton = productRoot ? productRoot.querySelector('[data-gallery-prev]') : null;
      this.galleryNextButton = productRoot ? productRoot.querySelector('[data-gallery-next]') : null;
      this.galleryVariantButtons = productRoot
        ? Array.from(productRoot.querySelectorAll('[data-gallery-variant]'))
        : [];
      this.galleryThumbImages = productRoot
        ? Array.from(productRoot.querySelectorAll('[data-gallery-thumb]'))
        : [];
      const sizeMapScript = productRoot ? productRoot.querySelector('[data-gallery-size-map]') : null;
      this.gallerySizeMap = sizeMapScript ? JSON.parse(sizeMapScript.textContent) : null;
      this.galleryVideo = productRoot ? productRoot.querySelector('.product__gallery-video') : null;
      this.galleryVariantOrder = ['ball', 'dog', 'studio', 'video', 'texture', 'usage', 'sizes', 'dogsize'];
      this.galleryVariant = 'ball';
      this.galleryColorEntry = null;

      if (this.galleryPrevButton) {
        this.galleryPrevButton.addEventListener('click', () => this.stepGallery(-1));
      }
      if (this.galleryNextButton) {
        this.galleryNextButton.addEventListener('click', () => this.stepGallery(1));
      }
      this.galleryVariantButtons.forEach((button) => {
        button.addEventListener('click', () => this.setGalleryVariant(button.dataset.galleryVariant));
      });

      this.syncGalleryToColor();

      this.quantityInput = this.querySelector('.product__quantity-input');
      this.querySelectorAll('.product__stepper-btn').forEach((button) => {
        button.addEventListener('click', () => this.onStepperClick(button));
      });

      this.moneyFormat = this.dataset.moneyFormat || ('€' + '{' + '{amount}' + '}');
      this.quantityTotal = this.querySelector('[data-quantity-total]');
      this.priceEl = productRoot ? productRoot.querySelector('.product__price') : null;
      this.freeShippingText = this.querySelector('[data-free-shipping-text]');
      this.unitPriceCents = this.quantityTotal ? parseInt(this.quantityTotal.dataset.unitPrice, 10) || 0 : 0;
      this.quantityInput.addEventListener('input', () => this.updateQuantityTotal());
      this.updateQuantityTotal();

      this.form = this.querySelector('.product__form');
      this.formError = this.querySelector('[data-form-error]');
      this.cartAddUrl = this.dataset.cartAddUrl || '/cart/add';
      this.boundOnSubmit = this.onSubmit.bind(this);
      this.form.addEventListener('submit', this.boundOnSubmit);

      this.setupAddedToast();
      this.setupStickyBar();
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.boundOnSubmit);
      document.removeEventListener('keydown', this.boundToastKeydown);
      window.clearTimeout(this.toastTimeoutId);
      if (this.stickyObserver) this.stickyObserver.disconnect();
    }

    setupAddedToast() {
      this.toast = this.querySelector('[data-added-toast]');
      if (!this.toast) return;

      this.toastLive = this.querySelector('[data-added-live]');
      this.toastImage = this.toast.querySelector('[data-toast-image]');
      this.toastLine = this.toast.querySelector('[data-toast-line]');

      this.toast.querySelector('[data-toast-close]').addEventListener('click', () => this.hideAddedToast(true));

      // Don't dismiss while the shopper is reading or aiming at a link.
      const pause = () => window.clearTimeout(this.toastTimeoutId);
      const resume = () => {
        if (!this.toast.matches(':hover, :focus-within')) this.scheduleToastHide(4000);
      };
      ['mouseenter', 'focusin', 'touchstart'].forEach((type) => this.toast.addEventListener(type, pause, { passive: true }));
      ['mouseleave', 'focusout', 'touchend'].forEach((type) => this.toast.addEventListener(type, () => window.setTimeout(resume, 0)));

      this.boundToastKeydown = (event) => {
        if (event.key === 'Escape' && this.toast.classList.contains('is-visible')) this.hideAddedToast(true);
      };
      document.addEventListener('keydown', this.boundToastKeydown);
    }

    scheduleToastHide(delay) {
      window.clearTimeout(this.toastTimeoutId);
      this.toastTimeoutId = window.setTimeout(() => this.hideAddedToast(false), delay);
    }

    showAddedToast(sourceImage, quantity) {
      if (!this.toast) return;

      const variant = this.variants.find((candidate) => String(candidate.id) === this.idInput.value);
      const parts = [this.toast.dataset.productTitle];
      if (variant && variant.title && variant.title !== 'Default Title') parts.push(variant.title);
      const line = `${parts.join(' · ')} × ${quantity}`;
      this.toastLine.textContent = line;

      const imageSrc = sourceImage && (sourceImage.currentSrc || sourceImage.src);
      this.toastImage.hidden = !imageSrc;
      if (imageSrc) this.toastImage.src = imageSrc;

      this.toast.classList.add('is-visible');
      this.scheduleToastHide(8000);

      // Focus stays on the button so another unit can be added by keyboard;
      // the live region carries the announcement.
      if (this.toastLive) {
        this.toastLive.textContent = '';
        window.setTimeout(() => {
          this.toastLive.textContent = `${this.toast.getAttribute('aria-label')} ${line}`;
        }, 50);
      }
    }

    hideAddedToast(returnFocus) {
      if (!this.toast) return;

      window.clearTimeout(this.toastTimeoutId);
      if (returnFocus && this.toast.contains(document.activeElement)) this.submitButton.focus();
      this.toast.classList.remove('is-visible');
    }

    // Mobile-only (CSS hides it above 900px): a bottom bar mirroring the
    // main button, shown while that button is off screen, so the buy action
    // stays one tap away on a long product page.
    setupStickyBar() {
      this.stickyBar = this.querySelector('[data-sticky-atc]');
      if (!this.stickyBar || !('IntersectionObserver' in window)) return;

      this.stickyButton = this.stickyBar.querySelector('[data-sticky-button]');
      this.stickyPrice = this.stickyBar.querySelector('[data-sticky-price]');
      this.stickyVariant = this.stickyBar.querySelector('[data-sticky-variant]');
      this.stickyButton.addEventListener('click', () => {
        if (this.submitButton.disabled) return;
        this.form.requestSubmit(this.submitButton);
      });

      this.stickyObserver = new IntersectionObserver(([entry]) => {
        const visible = !entry.isIntersecting;
        this.stickyBar.classList.toggle('is-visible', visible);
        document.body.classList.toggle('has-sticky-atc', visible);
      });
      this.stickyObserver.observe(this.submitButton);
    }

    syncStickyBar(variant) {
      if (!this.stickyButton || !variant) return;
      this.stickyButton.disabled = !variant.available;
      this.stickyButton.textContent = variant.available
        ? this.submitButton.dataset.addToCartLabel
        : this.submitButton.dataset.soldOutLabel;
      if (this.stickyPrice && typeof variant.price === 'number') {
        this.stickyPrice.textContent = formatMoney(variant.price, this.moneyFormat);
      }
      if (this.stickyVariant && variant.title) this.stickyVariant.textContent = variant.title;
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.submitButton.disabled || this.submitButton.classList.contains('is-loading')) return;

      this.hideFormError();
      this.submitButton.classList.add('is-loading');

      const sourceImage = this.getFlySourceImage();
      const formData = new FormData(this.form);

      try {
        const response = await fetch(`${this.cartAddUrl}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        const data = await response.json().catch(() => null);

        if (!response.ok) {
          const shopifyMessage = data && (data.description || data.message);
          this.showFormError(shopifyMessage || this.dataset.genericErrorLabel);
          return;
        }

        this.showAddedFeedback();
        this.showAddedToast(sourceImage, formData.get('quantity') || 1);
        await this.notifyCartUpdated(sourceImage);
      } catch (error) {
        this.showFormError(this.dataset.genericErrorLabel);
      } finally {
        this.submitButton.classList.remove('is-loading');
      }
    }

    getFlySourceImage() {
      const productRoot = this.closest('.product');
      if (!productRoot) return null;

      const activePanelImage = productRoot.querySelector('.product__gallery-radio:checked + .product__gallery-panel img');
      return activePanelImage || this.galleryMainImage || productRoot.querySelector('.product__gallery img');
    }

    showAddedFeedback() {
      const addedLabel = this.submitButton.dataset.addedLabel;
      if (!addedLabel) return;

      window.clearTimeout(this.addedFeedbackTimeoutId);
      const restoreLabel = this.submitButton.dataset.addToCartLabel;
      // Freeze the width so the button doesn't jump when the label changes.
      this.submitButton.style.minWidth = `${this.submitButton.offsetWidth}px`;
      this.submitButton.textContent = addedLabel;

      this.addedFeedbackTimeoutId = window.setTimeout(() => {
        this.submitButton.style.minWidth = '';
        if (this.submitButton.disabled) return;
        this.submitButton.textContent = restoreLabel;
      }, 2000);
    }

    // Cross-section messaging: main-product and header are independent
    // OS2.0 sections that can be reordered/omitted per template, so a
    // generic "cart updated" event (rather than reaching into the header's
    // DOM) is what carries the new item count, plus an optional fly-to-cart
    // source element, to whichever listener (if any) wants to react —
    // this event isn't specific to this form, so any future cart-changing
    // UI (quick-add, mini-cart) can dispatch the same shape.
    async notifyCartUpdated(sourceImage) {
      let itemCount;
      try {
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        itemCount = cart.item_count;
      } catch (error) {
        itemCount = undefined;
      }
      document.dispatchEvent(new CustomEvent('ballzi:cart:updated', { detail: { itemCount, sourceElement: sourceImage } }));
    }

    showFormError(message) {
      if (!this.formError) return;

      window.clearTimeout(this.addedFeedbackTimeoutId);
      this.submitButton.style.minWidth = '';
      this.hideAddedToast(false);
      if (!this.submitButton.disabled) {
        this.submitButton.textContent = this.submitButton.dataset.addToCartLabel;
      }

      this.formError.textContent = message;
      this.formError.hidden = false;
    }

    hideFormError() {
      if (!this.formError) return;
      this.formError.hidden = true;
    }

    onStepperClick(button) {
      const step = button.classList.contains('product__stepper-btn--increase') ? 1 : -1;
      const currentValue = parseInt(this.quantityInput.value, 10) || 1;
      this.quantityInput.value = Math.max(1, currentValue + step);
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onOptionChange(event) {
      this.updateIdealFor();
      this.updateSelectedColorLabel();
      // A size change keeps the current slide (the dog-size slide follows it);
      // a colour change goes back to the first slide.
      const colorChanged = !this.colorFieldset || !event || this.colorFieldset.contains(event.target);
      this.syncGalleryToColor(colorChanged);
      this.updateQuantityTotal();

      if (!this.fieldsets.length) return;

      const selectedOptions = this.fieldsets.map((fieldset) => {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });

      const variant = this.variants.find((variant) =>
        variant.options.every((option, index) => option === selectedOptions[index])
      );

      if (!variant) return;

      this.idInput.value = variant.id;
      this.submitButton.disabled = !variant.available;
      this.submitButton.textContent = variant.available
        ? this.submitButton.dataset.addToCartLabel
        : this.submitButton.dataset.soldOutLabel;
      this.syncStickyBar(variant);

      if (typeof variant.price === 'number') {
        this.unitPriceCents = variant.price;
        this.updateQuantityTotal();
        this.updatePrice(variant);
      }

      // Keep the URL on the selected variant so a refresh or a shared link
      // lands on the same size/colour and price. The default variant needs no
      // parameter, which keeps the common URL short.
      const defaultVariant = this.variants.find((candidate) => candidate.available) || this.variants[0];
      const url = new URL(window.location.href);
      if (variant.id === defaultVariant.id) {
        url.searchParams.delete('variant');
      } else {
        url.searchParams.set('variant', variant.id);
      }
      window.history.replaceState({}, '', url);
    }

    updateSelectedColorLabel() {
      if (!this.colorFieldset) return;
      const label = this.colorFieldset.querySelector('[data-selected-value]');
      const checked = this.colorFieldset.querySelector('input[type="radio"]:checked');
      if (label && checked) label.textContent = checked.value;
    }

    updatePrice(variant) {
      if (!this.priceEl) return;

      // textContent replaces the previous price and any old compare-at <s>.
      this.priceEl.textContent = formatMoney(variant.price, this.moneyFormat);

      if (typeof variant.compare_at_price === 'number' && variant.compare_at_price > variant.price) {
        const compareAt = document.createElement('s');
        compareAt.className = 'product__price-compare-at';
        compareAt.textContent = formatMoney(variant.compare_at_price, this.moneyFormat);
        this.priceEl.append(' ', compareAt);
      }
    }

    updateQuantityTotal() {
      if (!this.quantityTotal || !this.quantityInput) return;

      const quantity = parseInt(this.quantityInput.value, 10) || 1;
      this.quantityTotal.textContent = formatMoney(this.unitPriceCents * quantity, this.moneyFormat);

      if (this.freeShippingText) {
        const labels = this.freeShippingText.dataset;
        if (quantity >= 3) {
          this.freeShippingText.textContent = labels.reachedLabel;
        } else if (quantity === 2) {
          this.freeShippingText.textContent = labels.addOneLabel || labels.baseLabel;
        } else {
          this.freeShippingText.textContent = labels.baseLabel || labels.addOneLabel;
        }
      }
    }

    currentDogSizeImage() {
      if (!this.gallerySizeMap) return '';
      const checked = this.sizeFieldset && this.sizeFieldset.querySelector('input[type="radio"]:checked');
      return this.gallerySizeMap[checked ? checked.value : 'M'] || this.gallerySizeMap.M || '';
    }

    syncGalleryToColor(resetVariant = true) {
      if (!this.colorFieldset || !this.galleryColorMap) return;

      const checked = this.colorFieldset.querySelector('input[type="radio"]:checked');
      const value = checked ? checked.value : null;
      const entry = value ? this.galleryColorMap[value] : null;
      if (!entry) return;

      entry.dogsize = this.currentDogSizeImage();
      this.galleryColorEntry = entry;

      this.galleryThumbImages.forEach((img) => {
        const url = entry[img.dataset.galleryThumb];
        if (url) img.src = url;
      });

      if (resetVariant) {
        this.setGalleryVariant('ball');
      } else if (this.galleryVariant === 'dogsize' && this.galleryMainImage) {
        this.galleryMainImage.src = entry.dogsize;
      }
    }

    stepGallery(direction) {
      const order = this.galleryVariantOrder;
      const next = order[order.indexOf(this.galleryVariant) + direction];
      if (next) this.setGalleryVariant(next);
    }

    setGalleryVariant(variant) {
      if (!this.galleryColorEntry) return;

      const url = this.galleryColorEntry[variant];
      if (!url) return;

      const order = this.galleryVariantOrder;
      const goingForward = order.indexOf(variant) > order.indexOf(this.galleryVariant);
      this.galleryVariant = variant;

      const isVideo = variant === 'video';
      if (this.galleryVideo) {
        this.galleryVideo.hidden = !isVideo;
        if (isVideo) {
          this.galleryVideo.play().catch(() => {});
        } else {
          this.galleryVideo.pause();
        }
      }
      if (this.galleryMainImage) this.galleryMainImage.hidden = isVideo;
      if (!isVideo) this.slideGalleryImage(url, goingForward ? 'right' : 'left');

      this.galleryVariantButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.galleryVariant === variant);
      });

      if (this.galleryPrevButton) this.galleryPrevButton.hidden = variant === order[0];
      if (this.galleryNextButton) this.galleryNextButton.hidden = variant === order[order.length - 1];
    }

    slideGalleryImage(url, enterFrom) {
      const img = this.galleryMainImage;
      if (!img) return;

      const exitClass = enterFrom === 'right'
        ? 'product__gallery-main-image--offset-left'
        : 'product__gallery-main-image--offset-right';
      const enterClass = enterFrom === 'right'
        ? 'product__gallery-main-image--offset-right'
        : 'product__gallery-main-image--offset-left';

      img.classList.add(exitClass);

      window.setTimeout(() => {
        img.classList.add('is-sliding');
        img.classList.remove(exitClass);
        img.classList.add(enterClass);
        img.src = url;

        void img.offsetWidth;

        img.classList.remove('is-sliding');
        img.classList.remove(enterClass);
      }, 220);
    }

    updateIdealFor() {
      if (!this.sizeFieldset || !this.idealForText || !this.idealForMap) return;

      const checked = this.sizeFieldset.querySelector('input[type="radio"]:checked');
      const value = checked ? checked.value : null;
      const nextText = (value && this.idealForMap[value]) || this.idealForMap.__fallback__;

      if (!nextText || nextText === this.idealForText.textContent) return;

      this.idealForText.classList.add('product__ideal-for-text--swap');
      window.setTimeout(() => {
        this.idealForText.textContent = nextText;
        this.idealForText.classList.remove('product__ideal-for-text--swap');
      }, 180);
    }
  }

  customElements.define('product-variant-picker', ProductVariantPicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-bar"]) return;
  try {
    
  (function () {
    var PX_PER_SECOND = 40;
    var items = new Set();
    var timer = null;

    function tickAll() {
      items.forEach(function (item) { item.tick(); });
      if (!items.size) stopTimer();
    }

    function startTimer() {
      if (timer || document.hidden || !items.size) return;
      tickAll();
      timer = setInterval(tickAll, 1000);
    }

    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopTimer();
      else startTimer();
    });

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function digits(text) {
      return String(text).split('').map(function (c) {
        return '<span class="offer-bar__digit">' + c + '</span>';
      }).join('');
    }

    class OfferBar extends HTMLElement {
      connectedCallback() {
        this.end = parseInt(this.dataset.endTs, 10) * 1000;
        if (!this.end || this.done) return;

        this.timeEl = this.querySelector('[data-time]');
        this.srEl = this.querySelector('[data-offer-sr]');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.isLast = this.classList.contains('is-last-day');
        this.lastKey = null;
        this.lastMinute = null;

        try {
          this.dayFormat = new Intl.DateTimeFormat('en-CA', {
            timeZone: this.dataset.timezone || 'Europe/Paris',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          });
        } catch (error) {
          this.dayFormat = null;
        }

        // Sans bouton : tap/clic sur le texte = pause/reprise, seulement quand la
        // bande n'est pas un lien (fiche produit) pour ne pas bloquer la navigation.
        var textZone = this.querySelector('.offer-bar__text');
        if (textZone && !this.querySelector('.offer-bar__link') && !this.tapBound) {
          this.tapBound = true;
          textZone.addEventListener('click', function () {
            this.classList.toggle('is-paused');
          }.bind(this));
        }

        this.syncDuration();
        items.add(this);
        this.tick();
        startTimer();
      }

      disconnectedCallback() {
        items.delete(this);
        if (!items.size) stopTimer();
      }

      // Vitesse constante : la durée suit la largeur d'un groupe.
      syncDuration() {
        if (this.reduced) return;
        var group = this.querySelector('.offer-bar__group');
        var width = group ? group.offsetWidth : 0;
        if (width) this.style.setProperty('--offer-bar-duration', Math.round(width / PX_PER_SECOND) + 's');
      }

      // Le dernier jour se juge sur la date de Paris, jamais sur le fuseau du visiteur.
      isLastDay(now, seconds) {
        if (this.dayFormat && this.dataset.endDay) {
          return this.dayFormat.format(now) === this.dataset.endDay;
        }
        return seconds < 86400;
      }

      tick() {
        if (this.done) return;
        var now = Date.now();
        var s = Math.floor((this.end - now) / 1000);
        if (s <= 0) { this.finish(); return; }

        var last = this.isLastDay(now, s);
        if (last !== this.isLast) {
          this.isLast = last;
          this.classList.toggle('is-last-day', last);
          this.syncDuration();
        }

        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        var key = s < 86400 ? 's' + s : 'm' + Math.floor(s / 60);
        if (this.timeEl && key !== this.lastKey) {
          this.lastKey = key;
          this.timeEl.innerHTML = s < 86400
            ? digits(pad(h)) + '<span class="offer-bar__colon">:</span>' + digits(pad(m)) + '<span class="offer-bar__colon">:</span>' + digits(pad(sec))
            : digits(d) + '<span class="offer-bar__unit">j</span>' + digits(pad(h)) + '<span class="offer-bar__unit">h</span>' + digits(pad(m)) + '<span class="offer-bar__unit">min</span>';
        }

        // Annonce lecteur d'écran : une fois par minute, jamais les secondes.
        var minuteKey = Math.floor(s / 60);
        if (this.srEl && this.lastMinute !== minuteKey) {
          this.lastMinute = minuteKey;
          var parts = [];
          if (d > 0) parts.push(d + (d === 1 ? ' jour' : ' jours'));
          parts.push(h + (h === 1 ? ' heure' : ' heures'));
          parts.push(m + (m === 1 ? ' minute' : ' minutes'));
          var text = parts.slice(0, -1).join(', ') + ' et ' + parts[parts.length - 1];
          this.srEl.textContent = this.dataset.srPrefix + ' ' + text + '.';
        }
      }

      finish() {
        this.done = true;
        items.delete(this);
        this.hidden = true;
        var ended = this.parentNode && this.parentNode.querySelector('[data-offer-ended]');
        if (ended) ended.hidden = false;
      }
    }

    if (!customElements.get('offer-bar')) customElements.define('offer-bar', OfferBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-teaser"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-teaser')) {
    class ProductTeaser extends HTMLElement {
      connectedCallback() {
        this.photo = this.querySelector('.product-teaser__media img');
        this.button = this.querySelector('.product-teaser__button');
        this.dots = Array.from(this.querySelectorAll('[data-color-photo]'));
        if (!this.photo || this.dots.length === 0) return;

        this.baseHref = this.button ? this.button.getAttribute('href') : null;
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.select(dot));
          ['pointerenter', 'focus'].forEach((type) => {
            dot.addEventListener(type, () => this.preload(dot), { once: true });
          });
        });
      }

      preload(dot) {
        new Image().src = dot.dataset.colorPhoto;
      }

      select(dot) {
        if (dot.getAttribute('aria-pressed') === 'true') return;

        this.dots.forEach((other) => other.setAttribute('aria-pressed', String(other === dot)));

        if (this.button && this.baseHref && dot.dataset.variantId) {
          this.button.setAttribute('href', this.baseHref + '?variant=' + dot.dataset.variantId);
        }

        const photo = this.photo;
        const nextSrc = dot.dataset.colorPhoto;
        photo.classList.add('is-changing');
        window.setTimeout(() => {
          const reveal = () => photo.classList.remove('is-changing');
          photo.addEventListener('load', reveal, { once: true });
          photo.src = nextSrc;
          if (photo.complete) reveal();
        }, 180);
      }
    }

    customElements.define('product-teaser', ProductTeaser);
  }

  } catch(e) { console.error(e); }
})();
})();
